var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paragraphs"},[(false)?_vm._t("default"):_vm._e(),_vm._v(" "),_vm._l((_vm.paragraphs),function(paragraph,i){return _c('p',{key:i,staticClass:"paragraph",style:(_vm.paragraphStyle)},[_vm._v(_vm._s(paragraph))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a102bf7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/display/Paragraphs.vue
// module id = null
// module chunks = 